// eslint-disable-next-line import/prefer-default-export
export const TOAST_VARIABLES = {
    icons: {
        success: 'CheckIcon',
        error: 'AlertTriangleIcon'
    },
    variants: {
        success: 'success',
        error: 'danger',
    }
}